import script from "./Teams.vue?vue&type=script&setup=true&lang=js"
export * from "./Teams.vue?vue&type=script&setup=true&lang=js"

import "./Teams.vue?vue&type=style&index=0&id=59e156e6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e156e6"]])

export default __exports__